export const ARTWORK_PREVIEW_REFRESH_MS = 15_000;
export const ARTWORK_PREVIEW_REFRESH_WINDOW_MS = 2 * 60_000;

/**
 * Poll only while an opened Film batch still has a missing server-hosted
 * artwork preview. The deadline keeps a genuinely source-less item from
 * turning into permanent station traffic.
 */
export function artworkPreviewRefreshInterval(
  data: { garments: ReadonlyArray<{ artworkThumbUrl: string | null }> } | undefined,
  deadline: number,
  now = Date.now(),
): number | false {
  if (!data || data.garments.length === 0 || now >= deadline) return false;
  return data.garments.some((garment) => !garment.artworkThumbUrl)
    ? ARTWORK_PREVIEW_REFRESH_MS
    : false;
}
